import { useState } from 'react';
import { Offcanvas, Dropdown } from 'olive-react-myoneui';
import ReactTimeAgo from 'react-time-ago';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import UserImage from './UserImage';
import { trashIcon, deleteNotificationIcon, envelopeOpenIcon, verticalEllipsisIcon, partyIcon } from '../../../../constants/icons';
import ConfirmBox from '../ConfirmBox';
import NotificationModal from './NotificationModal';

TimeAgo.addDefaultLocale(en);

const staticNotifications = [
  {
    id: 1,
    message: "New comment on your post",
    sender: { profile_image: "", first_name: "John", last_name: "Doe" },
    createdAt: new Date(),
    isRead: false,
  },
  {
    id: 2,
    message: "Your profile was viewed",
    sender: { profile_image: "", first_name: "Jane", last_name: "Smith" },
    createdAt: new Date(),
    isRead: true,
  },
];

function NotificationOffCanvas({ show, onClose }) {
  const [data, setData] = useState(staticNotifications);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [item, setItem] = useState({});
  const [showConfirmBox, setShowConfirmBox] = useState(false);

  const toggleModal = (data) => {
    setItem(data);
    setShowNotificationModal((prevState) => !prevState);
  };

  const removeNotification = (id) => {
    setData(data.filter((item) => item.id !== id));
  };

  const deleteAllNotifications = () => {
    setData([]);
    setShowConfirmBox(false);
  };


  const handleDeleteAllNotifications = () => {
    setShowConfirmBox(true);
  };

  const handleHideConfirmBox = () => {
    setShowConfirmBox(false);
  };
  
  return (
    <>
      <Offcanvas className="pb-0" show={show} onHide={onClose} placement="end">
        <Offcanvas.Header closeButton>
          <div className="d-flex align-items-center gap-3">
            <div className="offcanvas-title h3">Notifications</div>
            <Dropdown className="dropdown-select text-end" align="end">
              <Dropdown.Toggle as="div" role="button" className="btn btn-icon rounded-circle">
                {verticalEllipsisIcon}
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu notify-dropdown">
                <Dropdown.Item>
                  <span className="d-flex align-items-center gap-1" role="button">
                    {envelopeOpenIcon} Mark all as read
                  </span>
                </Dropdown.Item>
                <Dropdown.Item>
                  <span
                    className="d-flex align-items-center gap-1 notification-delete"
                    role="button"
                    onClick={handleDeleteAllNotifications}
                  >
                    {deleteNotificationIcon} Delete All
                  </span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {data.length === 0 ? (
            <div className="party-notification">
              {partyIcon}
              <span>Everything is up to date!</span>
            </div>
          ) : (
            data.map((item) => (
              <div
                key={item.id}
                className={`notifications-block ${item.isRead ? '' : 'new-notification'}`}
                onClick={() => toggleModal(item)}
              >
                <div className="icon-wrap">
                  <UserImage src={item.sender.profile_image} title={`${item.sender.first_name} ${item.sender.last_name}`} />
                  {!item.isRead && <span className="notify-dot"></span>}
                </div>
                <div className="info-wrap">
                  <h4>{item.message}</h4>
                  <span>{item.createdAt && <ReactTimeAgo date={item.createdAt} />}</span>
                </div>
                <div
                  className="notification-delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeNotification(item.id);
                  }}
                >
                  {trashIcon}
                </div>
              </div>
            ))
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {showNotificationModal && (
        <NotificationModal
          show={showNotificationModal}
          toggleModal={toggleModal}
          item={item}
        />
      )}

      {showConfirmBox && (
        <ConfirmBox
          show={showConfirmBox}
          question="Are you sure you want to delete all notifications?"
          okText="Delete"
          cancelText="Cancel"
          onHide={handleHideConfirmBox}
          onOk={deleteAllNotifications}
        />
      )}
    </>
  );
}

export default NotificationOffCanvas;
